

import { Component, Vue, Prop, Watch, Inject } from 'vue-property-decorator';
import { CreateElement, VNode, VNodeDirective } from 'vue';
import { Validator } from 'vee-validate';
import Tabs from './tabs.vue';

@Component
export default class Tab extends Vue {
    @Inject('$validator') public $validator!: Validator;
    @Prop({ type: Boolean, default: false }) public active!: boolean;
    @Prop({ type: String, default: 'div' }) public tag!: string;
    @Prop({ type: String, default: '' }) public buttonId!: string;
    @Prop({ type: String, default: '' }) public title!: string;
    @Prop({ type: [String, Array, Object], default: null }) public titleItemClass!: string;
    @Prop({ type: [String, Array, Object], default: null }) public titleLinkClass!: string;
    @Prop({ type: String, default: '' }) public headHtml!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public noBody!: boolean;
    @Prop({ type: String, default: '#' }) public href!: string;

    public localActive: boolean = this.active && !this.disabled;
    private show: boolean = false;

    public get isTab(): boolean {
        return true;
    }
    public get fade(): boolean {
        return (this.$parent as Tabs).noFade;
    }
    public get lazy(): boolean {
        return (this.$parent as Tabs).lazy;
    }
    public get controlledBy(): string {
        return this.buttonId;
    }
    public get tabClasses(): Array<string> {
        return [
            'tab-pane',
            this.$parent && (this.$parent as Tabs).card && !this.noBody ? 'card-body' : '',
            this.show ? 'show' : '',
            this.fade ? 'fade' : '',
            this.disabled ? 'disabled' : '',
            this.localActive ? 'active' : '',
        ];
    }

    public beforeEnter() {
        window.requestAnimationFrame(() => { this.show = true; });
    }
    public beforeLeave() {
        this.show = false;
    }
    public render(h: CreateElement): VNode {

        // @ts-ignore
        let content: VNode = h(false);
        const directives = [{ name: 'show', value: this.localActive }];
        if (this.localActive || !this.lazy) {
            content = h(this.tag,
            // @ts-ignore
            {
                directives,
                ref: 'panel',
                class: this.tabClasses,
                attrs: {
                    'role': 'tabpanel',
                    'id': '',
                    'aria-hidden': this.localActive ? 'false' : 'true',
                    'aria-expanded': this.localActive ? 'true' : 'false',
                    'aria-labelledby': null,
                },
            },
            [this.$slots.default]);
        }

        return h('transition',
            {
                props: { mode: 'out-in' },
                on: {
                    beforeEnter: this.beforeEnter,
                    beforeLeave: this.beforeLeave,
                },
            },
            // @ts-ignore
            [content],
        );
    }
}
